import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper full-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleSelect = _resolveComponent("TitleSelect")!
  const _component_BackLink = _resolveComponent("BackLink")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Page, { navItems: _ctx.tabNavItems }, {
      header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "no-avatar-header" }, null, -1)
      ]))]),
      title: _withCtx(() => [
        _createVNode(_component_TitleSelect, {
          name: "track",
          class: _normalizeClass(!_ctx.isSmallScreen ? 'text-h5' : ''),
          items: _ctx.titleSelectItems,
          value: _ctx.titleSelectValue,
          onChange: _ctx.handleTitleNavChange
        }, null, 8, ["class", "items", "value", "onChange"])
      ]),
      back: _withCtx(() => [
        _createVNode(_component_BackLink, { url: "/reporting" })
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(`UserProgress`), {
          reportData: _ctx.reportData,
          rowData: _ctx.data,
          currentHotspot: _ctx.currentHotspot,
          onRefreshData: _ctx.getReportData,
          onSort: _ctx.handleSort,
          onUpdateSearch: _ctx.handleSearchChange,
          onUpdateFilter: _ctx.handleFilterChange,
          onApplyFilter: _ctx.handleFilterApply,
          onResetFilter: _ctx.handleFilterReset
        }, null, 40, ["reportData", "rowData", "currentHotspot", "onRefreshData", "onSort", "onUpdateSearch", "onUpdateFilter", "onApplyFilter", "onResetFilter"]))
      ]),
      footer: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" ", -1)
      ]))]),
      "content-footer__buttons": _withCtx(() => [
        _createVNode(_component_Button, {
          text: "reporting.download",
          size: "sm",
          onClick: _ctx.handleDownloadClick,
          block: ""
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["navItems"])
  ]))
}